import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgViceCaptainDimension = {
  height: 16,
  width: 16,
  viewBox: '0 0 16 16',
};
export const SvgViceCaptain = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#clip0_vicecaptain)">
      <mask
        id="mask0_vicecaptain"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#B90B13"
        />
      </mask>
      <g mask="url(#mask0_vicecaptain)">
        <path
          d="M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5Z"
          fill="#F5F5FF"
          stroke="#A036E0"
        />
      </g>
      <path
        d="M12.508 10.5345C12.1711 10.6597 11.8222 10.7222 11.4613 10.7222C10.6337 10.7222 10.0009 10.4792 9.56303 9.99317C9.12999 9.50236 8.91345 8.8311 8.91345 7.97939C8.91345 7.45489 9.00488 6.98573 9.18773 6.5719C9.37057 6.15327 9.64487 5.82366 10.0105 5.58306C10.3763 5.34246 10.8261 5.22217 11.3603 5.22217C11.6923 5.22217 12.0124 5.28232 12.3203 5.40261L12.4646 6.47808C12.1134 6.30966 11.7717 6.22545 11.4397 6.22545C10.9729 6.22545 10.6289 6.37462 10.4076 6.67296C10.1862 6.96649 10.0756 7.40196 10.0756 7.97939C10.0756 8.55201 10.2007 8.98748 10.4509 9.28583C10.701 9.57935 11.0789 9.72611 11.5841 9.72611C11.9209 9.72611 12.2288 9.66115 12.508 9.53123V10.5345Z"
        fill="#A036E0"
      />
      <path
        d="M7.0734 5.22217H8.30434L6.58399 10.7222H5.21958L3.49182 5.22217H4.75242L5.91662 9.5074L7.0734 5.22217Z"
        fill="#A036E0"
      />
    </g>
    <defs>
      <clipPath id="clip0_vicecaptain">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
